<template>
   <div class="orderDetails spackage padding-20 bgc box-shadow">
        <div class="flex head">
            <img :src="orderinfo.customericonurl" alt="customericonurl">
            <p style="line-height:50px">{{orderinfo.customername}}</p>
        </div>
        <div class="flex txt">
            <p>活动名称：<span>{{orderinfo.eventname}}</span></p>
            <p>订单号：<span>{{orderinfo.orderno}}</span></p>
            <p>订单状态：<span>{{orderinfo.orderstatustext }}</span></p>
        </div>
        <div class="flex txt">
            <p>所在社群：<span>{{orderinfo.assname}}</span></p>
            <p>订单金额：<span>{{orderinfo.orderprice}}</span></p>
            <p>订单时间：<span>{{orderinfo.ordertime}}</span></p>
        </div> 

       <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1">商品详情</el-menu-item>
       </el-menu>

        <el-table
            :data="orderinfo.productlist"
            style="width: 100%">
            <el-table-column
                label="商品名称">
                <template slot-scope="scope">
                    <div class="flex">
                        <img :src="scope.row.coveratturlid" alt="img" width="60px" height="60px">
                        <p class='name'>{{ scope.row.productname }}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="saleprice"
                label="商品单价">
            </el-table-column>
            <el-table-column
                prop="salecount"
                label="商品数量">
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="totalPage" @current-change="fPage"></el-pagination>
   </div>
</template>

<script>
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery'
import {getEventOrderInfo} from 'api/cPurchaseApi'
export default {
    name: "OrderDetails",
    data() {
        return {
            activeIndex: '1',
            totalPage: 0,
            orderinfo: [],
            dataapi: {
                orderno: this.$route.query.orderno,
                pgae: 1,
                pageSize: 10
            }
        }
    },
    mounted() {
        this.orderlist(1)
    },
    methods: {
        orderlist(page) {

            this.setLoading(true)
            this.dataapi.page = page

            getEventOrderInfo({
                data: this.dataapi,
                success: data => {
                    this.setLoading(false)
                    this.orderinfo = data.data
                },
                error: data => {
                    this.$message.error(this.msg)
                    this.setLoading(false)
                }
            })

        },
        fPage(){    // 分页
            let clickPage = $(".el-pagination .active").html()
            // console.log($('clickPage',$(".el-pagination .active").html()))
            this.orderlist(clickPage)
        },
        ...mapActions(['setLoading'])
    }
}
</script>

<style lang="scss" type="text/scss">
    .orderDetails {
        .head {
            margin-bottom: 10px;
            height: 50px;
            img {
                display: block;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background: #ccc
            }
            p {
                margin-left: 10px;
                font-size: 14px;
            }
        }
        .flex {
            display: flex;
            flex-wrap: nowrap;
            -ms-flex-wrap: nowrap;
            width: 100%;
        }
        .name {
            margin-left: 15px
        }
        .txt p {
            margin-top: 10px;
            display: block;
            width: 100%;
            font-size: 14px;
            color: #001529;
            span {
                font-size: 14px;
                color: #606266;
            }
        }
        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }
        .el-menu.el-menu--horizontal {
            margin-bottom: 30px;
        }
        .el-menu--horizontal>.el-menu-item.is-active {
            color: #409EFF;
        }
    }
</style>